module.exports = __webpack_public_path__ + "img/br.057f3318.svg";